export default __webpack_public_path__ + "static/media/registrazione-docenti-nc.b704d069.svg";